import { API_ENDPOINTS } from "../config/api/apiCall";
import { callApi } from "../utils/apiClient";

export const loadSalesOrderList = async (payload) => {
    try {
        // const payload = {
        //     p_companyid: localStorage.getItem('companyid') || 0,            
        // };

        return await callApi(API_ENDPOINTS.getCOList, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};